// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__wNRHw","separador":"styles_separador__LuRbi","contenedor":"styles_contenedor__pry2r","sentinel":"styles_sentinel__J9Zut"};